import React, {useEffect} from 'react';
import {Row, Col, CardBody, Card, Container, Button} from 'reactstrap';
import {useForm} from 'react-hook-form';
import {connect} from 'react-redux';
import {Link, useNavigate} from 'react-router-dom';
import {loginUser, apiError} from '../../store/actions';
import logoImg from '../../assets/images/logo-brother.svg';
import {getLoggedInUser} from '../../helpers/fakebackend_helper';

const Login = ({loginUser, loading}) => {
  const navigate = useNavigate();
  const {register, handleSubmit, formState: {errors}} = useForm();
  const authUser = getLoggedInUser();

  const onSubmit = (data) => {
    loginUser(data);
  };

  useEffect(() => {
    if (!authUser) return;

    if (authUser.user?.role === 'dispatcher') {
      navigate('/dispatch');
    } else {
      navigate('/dashboard');
    }
  }, [authUser, navigate]);

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
              <Card className="overflow-hidden">
                <div className="bg-dark mb-4 p-4">
                  <Row>
                    <Col className="col-7">
                      <div className="px-4">
                        <h3 className="text-yellow mb-0">Brother TECNET</h3>
                        <p className="text-white">
                          {process.env.REACT_APP_REALM.toUpperCase() + ' '}
                          Dealer Service Platform
                        </p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-center text-right">
                      <div className="px-4">
                        <img src={logoImg} alt="" className="img-fluid"/>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody>
                  <Row>
                    <Col md={6} sm={12}>
                      <div className="p-4">
                        <h5 className="mb-3">Just one more step away</h5>
                        <p>
                          The next level begins with Brother TECNET.
                          This platform has been developed for certified
                          dealers of Brother Internationale
                          Industriemachinen GmbH in order to optimize
                          processes and further increase the service for
                          our end customers.
                        </p>
                      </div>
                    </Col>
                    <Col md={6} sm={12}>
                      <div className="p-4">
                        <form onSubmit={handleSubmit(onSubmit)}>
                          <div className="form-group font-size-13">
                            <label>E-Mail address</label>
                            <input
                              type="email"
                              placeholder="Enter E-Mail address"
                              className="form-control"
                              {...register('email', {required: 'Email is required'})}
                            />
                            {errors.email && (
                              <small className="text-danger">{errors.email.message}</small>
                            )}
                          </div>

                          <div className="form-group font-size-13">
                            <label>Password</label>
                            <input
                              type="password"
                              placeholder="Enter password"
                              className="form-control"
                              {...register('password', {required: 'Password is required'})}
                            />
                            {errors.password && (
                              <small className="text-danger">{errors.password.message}</small>
                            )}
                          </div>

                          <div className="mt-3">
                            <Button
                              className="btn btn-dark btn-block waves-effect waves-light"
                              type="submit"
                              disabled={loading}
                            >
                              {loading && <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"/>}
                              Log In
                            </Button>
                          </div>

                          <div className="mt-4 font-size-13">
                            <Link to="/forgot-password">
                              <i className="mdi mdi-lock mr-1 mdi-24px text-yellow"/>
                              Forgot your password?
                            </Link>
                          </div>
                        </form>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <div className="mt-5 text-center font-size-13">
                <p>
                  Don&apos;t have an account?{' '}
                  <Link to="/register" className="font-weight-bold text-yellow">
                    Signup now
                  </Link>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const {error, loading} = state.Login;
  return {error, loading};
};

export default connect(mapStatetoProps, {loginUser, apiError})(Login);
